<!-- eslint-disable vue/no-v-html -->
<template>
  <page>
    <page
      :custom-style="{
        paddingBottom: showBottom ? '60px' : '0',
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
        boxSizing: 'border-box'
      }"
    >
      <div class="panel">
        <div id="keyContent" v-html="content"></div>
      </div>
    </page>
    <div v-if="showBottom" class="bottom-panel">
      <div class="btn" @click="agreenClick(false)">返回</div>
      <div class="btn agreen" @click="agreenClick(true)">同意</div>
    </div>
  </page>
</template>
<script>
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import { DialogAlert } from '@/utils/dialog.js'
import { Bridge } from '@mc/mc-jsbridge'
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '廉洁协议'
      })
      document.title = '廉洁协议'
    })
  },
  data() {
    return {
      showBottom: false,
      content: ''
    }
  },
  created() {
    this.getContent()
  },
  methods: {
    /**
     * [获取协议所有内容]
     */
    async getContent() {
      this.$Loading()
      try {
        const res = await API.account.companyProtocolQuery()
        // eslint-disable-next-line eqeqeq
        this.showBottom = res.accept_lianjie == 2
        this.content = res.content
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    async signProtocol() {
      this.$Loading()
      try {
        await API.account.signProtocol({ accept_lianjie: 1 })
        DialogAlert('协议签署成功')
        Bridge.call('mcsc.refreshNotification', {
          type: 'UserProtocol'
        })
        this.getContent()
      } catch (error) {
        DialogAlert('协议签署失败')
      }
      this.$Loading.hide()
    },
    agreenClick(flag) {
      if (flag) {
        this.signProtocol()
      } else {
        this.goBack()
      }
    },
    goBack() {
      this.$back()
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom-panel {
  position: fixed;
  bottom: 0;
  left: 0;

  width: 100%;

  padding: 14px 15px;

  background: #ffffff;

  @include flex-row-between;

  .btn {
    background: #9f9f9f;
    padding: 10px 20px;

    border-radius: 8px;

    font-size: 16px;
    text-align: center;
    color: #ffffff;
    &.agreen {
      background: #0daf52;
    }
  }
}
.panel {
  padding: 15px 15px 10px;
  .company {
    margin-bottom: 20px;
    h2 {
      margin: 5px 0;

      font-size: 16px;
      color: #333333;
    }
    p {
      margin: 5px 0;

      line-height: 22px;
      color: #666666;
      a {
        color: #4990e2;
      }
    }
  }
}
#keyContent {
  ::v-deep h2 {
    margin: 20px 0 5px;

    font-size: 18px;
    color: #333333;
  }
  ::v-deep p {
    margin: 5px 0;

    font-size: 14px;
    line-height: 22px;
    color: #333333;
    a {
      color: #4990e2;
    }
  }
}
</style>
